import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Col, Row } from "reactstrap"

const Paginations = ({ currentPage, totalPages, onPageChange, totalCount }) => {

  const { t } = useTranslation()

  const handleClickPrevious = () => {
    onPageChange(Math.max(currentPage - 1, 1)) // Update data for previous page
  }

  const handleClickNext = () => {
    onPageChange(Math.min(currentPage + 1, totalPages)) // Update data for next page
  }

  const handleClickPage = page => {
    onPageChange(page) // Update data for selected page
  }

  // Function to generate page numbers with ellipsis
  const generatePageNumbers = () => {
    const pageNumbers = []
    const range = 2 // Number of page numbers to show before and after the current page
    let start = Math.max(1, currentPage - range)
    let end = Math.min(totalPages, currentPage + range)

    // Add ellipsis and first page if currentPage is not at the beginning
    if (currentPage > range + 1) {
      pageNumbers.push(
        <li key={1} className="paginate_button page-item">
          <Link to="#" className="page-link" onClick={() => handleClickPage(1)}>
            1
          </Link>
        </li>
      )
      pageNumbers.push(
        <li key="ellipsis-start" className="paginate_button page-item disabled">
          <Link to="#" className="page-link">
            ...
          </Link>
        </li>
      )
    }

    // Generate page numbers around the current page
    for (let i = start; i <= end; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`paginate_button page-item ${
            currentPage === i ? "active" : ""
          }`}
        >
          <Link to="#" className="page-link" onClick={() => handleClickPage(i)}>
            {i}
          </Link>
        </li>
      )
    }

    // Add ellipsis and last page if currentPage is not at the end
    if (currentPage < totalPages - range) {
      pageNumbers.push(
        <li key="ellipsis-end" className="paginate_button page-item disabled">
          <Link to="#" className="page-link">
            ...
          </Link>
        </li>
      )
      pageNumbers.push(
        <li key={totalPages} className="paginate_button page-item">
          <Link
            to="#"
            className="page-link"
            onClick={() => handleClickPage(totalPages)}
          >
            {totalPages}
          </Link>
        </li>
      )
    }

    return pageNumbers
  }

  return (
    <Row className="align-items-center">
      <Col sm={12} md={5}>
        <div className="dataTables_info">
          {/* Showing {getPageOptions().length} of {getState().totalCount} Results */}
          {t("Total Records")} {totalCount}
        </div>
      </Col>
      <Col sm={12} md={7}>
        <div className={"paginationWrapper"}>
          <ul className={"pagination"}>
            <li
              className={`paginate_button page-item previous ${
                currentPage === 1 ? "disabled" : ""
              }`}
            >
              <Link to="#" className="page-link" onClick={handleClickPrevious}>
                <i className="mdi mdi-chevron-left"></i>
              </Link>
            </li>
            {/* {getPageOptions().map((item, key) => (
              <li
                key={key}
                className={`paginate_button page-item ${
                  getState().pagination.pageIndex === item ? "active" : ""
                }`}
              >
                <Link
                  to="#"
                  className="page-link"
                  onClick={() => setPageIndex(item)}
                >
                  {item + 1}
                </Link>
              </li>
            ))} */}
            {generatePageNumbers()}
            <li
              className={`paginate_button page-item next ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <Link to="#" className="page-link" onClick={handleClickNext}>
                <i className="mdi mdi-chevron-right"></i>
              </Link>
            </li>
          </ul>
        </div>
      </Col>
    </Row>
  )
}

export default Paginations
